import React, { useEffect, useState } from 'react';
import axios from 'axios';
import APIEndPoints from '../../../middleware/APIEndPoints';

const EducationHistory = () => {
  const [educationHistory, setEducationHistory] = useState([]);
  const [newEducation, setNewEducation] = useState({ school: '', degree: '', duration: '', description: '' });
  const [editEducation, setEditEducation] = useState(null);
  const baseUrl = APIEndPoints.educationhistory.url;

  // Fetch all education history records
  const fetchEducationHistory = async () => {
    try {
      const response = await axios.get(baseUrl);
      setEducationHistory(response.data);
    } catch (error) {
      console.error('Error fetching education history:', error);
    } 
  };

  // Add new education history record
  const addEducationHistory = async () => {
    try {
      const response = await axios.post(baseUrl, newEducation);
      setEducationHistory([...educationHistory, response.data]);
      setNewEducation({ school: '', degree: '', duration: '', description: '' });
    } catch (error) {
      console.error('Error adding education history:', error);
    }
  };

  // Update existing education history record
  const updateEducationHistory = async () => {
    try {
      const response = await axios.put(`${baseUrl}/${editEducation._id}`, editEducation);
      setEducationHistory(educationHistory.map(edu => (edu._id === editEducation._id ? response.data : edu)));
      setEditEducation(null);
    } catch (error) {
      console.error('Error updating education history:', error);
    }
  };

  // Delete education history record
  const deleteEducationHistory = async (id) => {
    try {
      await axios.delete(`${baseUrl}/${id}`);
      setEducationHistory(educationHistory.filter(edu => edu._id !== id));
    } catch (error) {
      console.error('Error deleting education history:', error);
    }
  };

  useEffect(() => {
    fetchEducationHistory();
  }, []);

  return (
    <div className="bg-[#1d0c39] min-h-screen p-8 text-white">
      <h1 className="text-3xl font-bold mb-6">Education History</h1>
      
      {/* Add New Education History Form */}
      <div className="mb-8">
        <h2 className="text-xl mb-4">Add New Education History</h2>
        <input
          type="text"
          placeholder="School"
          value={newEducation.school}
          onChange={(e) => setNewEducation({ ...newEducation, school: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <input
          type="text"
          placeholder="Degree"
          value={newEducation.degree}
          onChange={(e) => setNewEducation({ ...newEducation, degree: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <input
          type="text"
          placeholder="Duration"
          value={newEducation.duration}
          onChange={(e) => setNewEducation({ ...newEducation, duration: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <textarea
          placeholder="Description"
          value={newEducation.description}
          onChange={(e) => setNewEducation({ ...newEducation, description: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <button onClick={addEducationHistory} className="bg-green-600 px-4 py-2 rounded hover:bg-green-700">
          Add Education History
        </button>
      </div>

      {/* Edit Education History Form */}
      {editEducation && (
        <div className="mb-8">
          <h2 className="text-xl mb-4">Edit Education History</h2>
          <input
            type="text"
            placeholder="School"
            value={editEducation.school}
            onChange={(e) => setEditEducation({ ...editEducation, school: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <input
            type="text"
            placeholder="Degree"
            value={editEducation.degree}
            onChange={(e) => setEditEducation({ ...editEducation, degree: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <input
            type="text"
            placeholder="Duration"
            value={editEducation.duration}
            onChange={(e) => setEditEducation({ ...editEducation, duration: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <textarea
            placeholder="Description"
            value={editEducation.description}
            onChange={(e) => setEditEducation({ ...editEducation, description: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <button onClick={updateEducationHistory} className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 mr-2">
            Update Education History
          </button>
          <button onClick={() => setEditEducation(null)} className="bg-gray-600 px-4 py-2 rounded hover:bg-gray-700">
            Cancel
          </button>
        </div>
      )}

      {/* List of Education History */}
      <div>
        <h2 className="text-xl mb-4">Existing Education History</h2>
        {educationHistory.length === 0 ? (
          <p>No education history available.</p>
        ) : (
          educationHistory.map((edu) => (
            <div key={edu._id} className="border-b border-gray-500 pb-4 mb-4">
              <h3 className="text-lg font-semibold">{edu.school}</h3>
              <p>Degree: {edu.degree}</p>
              <p>Duration: {edu.duration}</p>
              <p>Description: {edu.description}</p>
              <button
                onClick={() => setEditEducation(edu)}
                className="bg-yellow-600 px-4 py-2 rounded hover:bg-yellow-700 mr-2 mt-2"
              >
                Edit
              </button>
              <button
                onClick={() => deleteEducationHistory(edu._id)}
                className="bg-red-600 px-4 py-2 rounded hover:bg-red-700 mt-2"
              >
                Delete
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default EducationHistory;
